/* eslint-disable react/prop-types */
import { Box, Grid } from "@mui/material";
import React, { useEffect, useState } from "react";
import InputField from "../../../components/common/new/InputField/InputField";
import { isEmptyObj } from "../../../utils/helper";
import useParamsQuery from "../../../hooks/useParamsQuery";
import DateRangePicker from "../../../components/common/DateRangePicker/DateRangePicker";

const initialFormValue = {
  applicationFrom: "",
  applicationTo: "",
  allotmentFrom: "",
  allotmentTo: "",
};

function PersonalDetailsSearch() {
  const { getQueryObject, getQueryParams, urlSearchParams } = useParamsQuery();
  const [initialAdvanceFormValue, setInitialAdvanceFormValue] =
    useState(initialFormValue);
  const [fullName, setFullName] = useState("");
  const [memberId, setMemberId] = useState("");

  useEffect(() => {
    const queryObject = getQueryObject();
    if (!isEmptyObj(queryObject)) {
      const query = getQueryParams(queryObject)[0];
      Object.keys(initialFormValue).forEach((key) => {
        setInitialAdvanceFormValue((prev) => ({
          ...prev,
          [key]: query[key] ?? "",
        }));
      });
      setFullName(query?.fullName || "");
      setMemberId(query?.memberId || "");
    } else {
      setInitialAdvanceFormValue(initialFormValue);
      setFullName("");
      setMemberId("");
    }
  }, [urlSearchParams.toString()]);

  return (
    <Box
      sx={{
        width: "100%",
        pr: { xs: "20px", sm: 0 },
        // ✅ Global styling
        "& .MuiInputBase-root": {
          height: "35px !important",
          fontSize: "12px",
          borderRadius: "8px",
          display: "flex",
          alignItems: "center",
        },
        "& .MuiInputLabel-root": {
          fontSize: "12px !important",
          fontWeight: 600,
          lineHeight: "1",
        },
        "& .MuiInputLabel-shrink": {
          lineHeight: "1.4375em",
        },
        "& .MuiOutlinedInput-input": {
          padding: "7px 14px !important",
          height: "21px !important",
          fontSize: "12px",
        },
        "& .MuiOutlinedInput-notchedOutline": {
          borderRadius: "8px",
        },
        "& .MuiTextField-root": {
          "& .MuiInputBase-root": {
            height: "35px",
            alignItems: "center",
          },
        },
        "& .MuiInputBase-input": {
          height: "auto !important",
          padding: "7px 14px !important",
        },
      }}
    >
      <Grid
        container
        spacing={2}
        sx={{
          display: "grid",
          gridTemplateColumns: {
            xs: "1fr",
            sm: "1fr 1fr",
            md: "repeat(4, 1fr)",
          },
          rowGap: 2,
          columnGap: 2,
        }}
      >
        {/* Group 1: Member ID & Name */}
        <Grid
          item
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 3,
            padding: 1,
            boxShadow: "1px 0 2px 0 #e7e2e2",
          }}
        >
          <InputField
            label="Member ID"
            name="memberId"
            value={memberId}
            onChange={(e) => {
              const onlyNums = e.target.value.replace(/\D/g, "");
              setMemberId(onlyNums);
            }}
          />
          <InputField
            label="Member Name"
            name="fullName"
            value={fullName}
            onChange={(e) => {
              const { value } = e.target;
              const regex = /^[A-Za-z ]*$/;
              if (regex.test(value)) {
                setFullName(value);
              }
            }}
          />
        </Grid>

        {/* Group 2: Dates */}
        <Grid
          item
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 3,
            padding: 1,
            boxShadow: "1px 0 2px 0 #e7e2e2",
          }}
        >
          <DateRangePicker
            label="Application Date"
            name="application"
            startDateVal={initialAdvanceFormValue.applicationFrom}
            endDateVal={initialAdvanceFormValue.applicationTo}
          />
          <DateRangePicker
            label="Allotment Date"
            name="allotment"
            startDateVal={initialAdvanceFormValue.allotmentFrom}
            endDateVal={initialAdvanceFormValue.allotmentTo}
          />
        </Grid>

        {/* Group 3: Empty */}
        <Grid
          item
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 3,
            padding: 1,
            boxShadow: "1px 0 2px 0 #e7e2e2",
          }}
        >
          {/* Empty group for future use */}
        </Grid>

        {/* Group 4: Empty */}
        <Grid
          item
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 3,
            padding: 1,
            boxShadow: "1px 0 2px 0 #e7e2e2",
          }}
        >
          {/* Empty group for future use */}
        </Grid>
      </Grid>
    </Box>
  );
}

export default PersonalDetailsSearch;
